import { useDataLoaderHooks } from './use-dataloader-hooks'
import {
  UseShoppingCart,
  UseShoppingCartProps,
} from '@dustin-web/microsite-data/src/hooks/use-shopping-cart-internal'
export type { UpdateCart } from '@dustin-web/microsite-data/src/hooks/use-shopping-cart-internal'

export const useShoppingCart: UseShoppingCart = (props: UseShoppingCartProps = {}) => {
  const { shoppingcart } = useDataLoaderHooks()

  return (
    shoppingcart(props) || {
      data: null,
      error: null,
      loading: true,
      updateCart: () => {},
      cartItems: [],
    }
  )
}

export default useShoppingCart
